<template>
  <div class="other-login-container">
    <div class="other-login-content">
      <div class="title-container">
<!--        <i class="logo"></i>-->
        <img
            class="logo"
            src="https://static.gaojidata.com/gaojidata/logo/new-title-blue.svg"
            alt=""
        />
      </div>
      <div class="phone-register">
        <p>返回<a href="javascript:void(0)" @click="goto_login">登录</a></p>
        <div class="other-icon-box">
          <h3>第三方账号绑定</h3>
          <ul>
              <li class="logo-icon"></li>
              <li class="trans-icon"></li>
              <li :class="flag==2? 'wecha-icon' : flag == 3?  'qq-icon' : 'weibo-icon'"></li>
          </ul>
					<div>您已通过{{flag==2? '微信' : flag == 3?  'QQ' : '微博'}}授权，完成以下信息即可完成绑定</div>
        </div>
				<el-form label-position="top" :model="checkForm" :rules="checkRulesForm" ref="checkForm"  :key="'checkRulesForm'" label-width="100px">
					<el-form-item label="账号" prop="account" class="no-tips">
						<el-input placeholder="请输入账号" v-model="checkForm.account" maxlength="80">
						</el-input>
						<span slot="error" slot-scope="error" class="el-form-item__error">{{error.error}}</span>
					</el-form-item>
					<el-form-item label="密码" prop="password" class="no-tips">
						<!-- <el-input type="password" v-model="ruleForm.password" autocomplete="off"></el-input> -->
						<el-input :type="showPassword? 'text' : 'password'" maxlength="32" v-model="checkForm.password" autocomplete="off"  placeholder="请输入密码" ref="password">
							<i slot="suffix" class="el-icon-invisible" @click="showPwd('showPassword')" :class="{see: showPassword}"></i>
						</el-input>
						<span slot="error" slot-scope="error" class="el-form-item__error">{{error.error}}</span>
					</el-form-item>
					<el-form-item>
						<el-button :loading="loading" type="button" @click="addThirdpartyAccount()">登录并绑定已有账号</el-button>
					</el-form-item>
				</el-form>
      </div>
      <div class="tips">建议使用<i class="el-icon-other-login-chrome"></i>Chrome浏览器</div>
    </div>
    <div class="footer-content">
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import { validUsername } from '@/utils/validate'
import Footer from '@/components/Footer/index.vue'
import { addThirdpartyAccount } from '@/api/login'
import { mapMutations } from 'vuex';
import {getToken, removeToken, setTokenTime} from '@/utils/auth';
import {getSessionStorage, setSessionStorage} from "@/utils/session";
export default {
  name: 'otherLogin',
  components: { Footer },
  data() {
    return {
      showPassword: false,
      loading: false,
			waiting: false,
			flag:null,
      code:'',
			uidType: null,
      checkForm: {
        account: '',
        password: '',
			},
      checkRulesForm: {
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' }
        ],
        account: [
          { required: true, message: '账号不能为空', trigger: 'blur' }
        ]
      },
    };
	},
	mounted(){
		let {uid, flag, status, code} = this.queryParams(location.hash);
		this.flag = flag;
		this.uid = uid;

		this.uidType = (this.flag == 2)? 'wechatUnionid' : (this.flag == 3)? 'qqUid' : 'sinaUid';

		if(status == 0) {
			this.login()
		} else if(status == 1) {
			this.$router.push('/profile?current=otherAccount')
		} else if(status == 'v2') {
			this.$router.push('/profile?current=otherAccount', () => {
				this.$message.error('该微信已绑定其他高绩账号，您可以使用微信登录高绩平台，在【个人中心—第三方账号绑定】页面解除绑定')
			})
		} else if(status == 'v3') {
			this.$router.push('/profile?current=otherAccount', () => {
				this.$message.error('该QQ已绑定其他高绩账号，您可以使用QQ登录高绩平台，在【个人中心—第三方账号绑定】页面解除绑定')
			})
		} else if(status == 'v4') {
			this.$router.push('/profile?current=otherAccount', () => {
				this.$message.error('该微博已绑定其他高绩账号，您可以使用微博登录高绩平台，在【个人中心—第三方账号绑定】页面解除绑定')
			})
		}
	},
  methods: {
		// ...mapMutations('login', ['SET_LOGINTYPE']),
		queryParams(hash){
			let params = {};
			let queryStr = hash.split('?')[1];
			if(queryStr) {
				let paramList = queryStr.split('&');
				paramList.forEach(param => {
					params[param.split('=')[0]] = param.split('=')[1]
				});
			}
			return params;
		},
    goto_login(){
			// this.SET_LOGINTYPE('message');
			this.$router.push({path: '/login'});
    },
    showPwd(name) {
      this[name] = !this[name];
		},
		addThirdpartyAccount() {
      this.loading = true
      const url = getSessionStorage('loginUrl')
      const payload = {
        loginName: this.checkForm.account,
        password: this.checkForm.password,
        // [this.uidType]: this.uid
        openId:this.uid // 'wxdf1270941c48d186'
      }
      if(url){
        payload.url = url
      }
			addThirdpartyAccount(payload).then(res => {
				this.login()
			}).catch(err => {
				this.loading = false;
			})
		},
		login(){
      const url = getSessionStorage('loginUrl')
      const payload = {
        code:this.uid
      }
      if(url){
        payload.url = url
      }
			this.$store.dispatch('user/loginByWx', payload).then(res => {
        const url = getSessionStorage('loginUrl')
        if(url){
          this.loading = false;
          const token = getToken()
          const target = decodeURIComponent(url) + '?token=' + token
          // setSessionStorage('loginUrl','')
          // removeToken()
          window.location = target
        }else{
          this.$router.push({ path: '/'})
          this.loading = false;
        }

			})
			.catch((err) => {
				console.log(err);
				this.loading = false
			})
		},
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
}
</script>

<style lang="scss">
/* 修复input 背景不协调 和光标变色 */
/* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */

.el-form--label-top .el-form-item__label{
  line-height: 14px;
  min-height: 24px;
  min-width: 1px;
}
.get-check_code{
  input{
    &:focus{
      box-shadow: none!important;
    }
    border-color: #514DEF;
    color: #514DEF;
    background-color: #FFFFFF;
    cursor: pointer;
    &:hover{
      color: #FFFFFF;
      background-color: #5F5BFB;
      border-color: #5F5BFB;
    }
    &.diabled{
      color: #C4C3EF;
      background-color: #FFFFFF;
      border-color: #D8D7FE;
    }
  }
  .wait{
    input, input:hover{
      cursor: not-allowed;
      color: #C4C3EF;
      border-color: #D8D7FE;
      background-color: #ffffff;
      width: 100px;
    }
  }
}
.prefix-box{
	.el-input--medium .el-input__inner{
		padding-left: 58px;
	}
}
</style>

<style lang="scss" scoped>
$bg:#e1e1e1;
$dark_gray:#889aa4;
$light_gray:#eee;

.other-login-container {
  min-height: 768px;
  padding-top: 20px;
  width: 100%;
  overflow: hidden;
  background: url('~@/assets/images/bg_login.png') no-repeat;
  background-size: 100% auto;
  background-position: center bottom;
  background-color: #f7f7fc;
  .other-login-content{
    min-height: calc(100vh - 149px);
    width: 462px;
    position: relative;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .title-container{
      height: 67px;
      text-align: center;
      .logo {
        height: 100%;
        width: 180px;
        transform: translateY(15px);
        display: inline-block;
        //background: url('~@/assets/newLogo.png') no-repeat;
        //background-position: center center;
        //background-size: 100% auto;
      }
    }
    .phone-register {
      height: 512px;
      max-height: 100%;
      position: relative;
      padding:0 47px;
      box-shadow: 0px 5px 21px 0px rgba(81, 77, 239, 0.08);
      border-radius: 5px;
      box-sizing: border-box;
      background: #FFFFFF;
      position: relative;
      margin: 60px 0 20px;
      p{
        position: absolute;
        top: -27px;
        right: 0;
        font-size: 14px;
        font-family: 'Source Han Sans SC';
        font-weight: 400;
        color: #343438;
        height: 14px;
        line-height: 14px;
        a{
          color: #514DEF;
          // text-decoration: underline;
          border-bottom: solid thin;
          display: inline-block;
        }
      }
      .change-success-box {
        height:calc(100% - 181px);
        display: flex;
        justify-content: center;
        align-items: center;
        dl{
          display: inline-block;
          font-size: 14px;
          font-family: 'Source Han Sans SC';
          font-weight: 400;
          color: #514DEF;
          text-align: center;
          dd{
            &:first-child{
              margin-bottom: 19px;
            }
          }
        }
      }
      .other-icon-box{
				font-size: 14px;
        h3{
          text-align: center;
          height: 16px;
          font-size: 16px;
          line-height: 16px;
          font-family: 'Source Han Sans SC';
          font-weight: bold;
          color: #444444;
          margin: 30px 0 36px;
        }
				div{
					text-align: center;
					line-height: 14px;
					margin: 36px 0 48px;
				}
        ul{
          display: flex;
					justify-content: center;
          li{
            text-align: center;
            width: 34px;
						height: 28px;
            position: relative;
						background-repeat: no-repeat;
						background-size: contain;
						&.logo-icon{
							width: 30px;
							height: 28px;
							background-image: url('../../../assets/gaojilogo.svg');
						}
						&.trans-icon{
							width: 25px;
							height: 21px;
							transform: scale(1.5);
    					background-size: cover;
							margin: 0 28px;
							background-image: url('../../../assets/change.svg');
						}
						&.wecha-icon{
							background-image: url('../../../assets/images/btn_settings_wechat.png');
						}
						&.qq-icon{
							background-image: url('../../../assets/images/btn_settings_qq.png');
						}
						&.weibo-icon{
							background-image: url('../../../assets/images/btn_settings_sina.png');
						}
          }
        }
      }
      .el-icon-invisible{
        display: inline-block;
        width: 36px;
        height: 100%;
        background: url('~@/assets/images/btn_key_invisible_normal.png') no-repeat;
        background-position: center;
        cursor: pointer;
        &:hover {
          background-image: url('~@/assets/images/btn_key_invisible_hover.png');
        }
        &.see{
          background-image: url('~@/assets/images/btn_key_visible_normal.png');
          &:hover{
            background-image: url('~@/assets/images/btn_key_visible_hover.png');
          }
        }
      }
      .config-box{
        display: flex;
        justify-content: space-between;
        &>span:first-child{
          display: flex;
          align-items: center;
          color: #444444;
        }
        &>span:last-child{
          color: #A4A4AD;
        }
      }
      .el-form-item__error {
        color: #F56C6C;
        font-size: 12px;
        line-height: 1;
        padding-top: 4px;
        position: absolute;
        left: initial;
        top: -10px;
        right: 0px;
        transform: translateY(-100%);
      }
      .el-form-item {
				margin-bottom: 17px;
				&.prefix-box{
					.el-input--medium .el-input__inner{
						padding-left: 52px;
					}
					span.el-input__prefix{
						width: 43px;
						i{
							font-style: normal;
							color: #343438;
							font-size: 14px;
							line-height: 16px;
							height: 16px;
							display: inline-block;
							margin-top: 14px;
							border-right: solid thin #E1E1E3;
							width: 48px;
							text-align: center;
							margin-left: -5px;
						}
					}
				}
      }
      .el-button{
        width: 100%;
        margin-top: 55px;
        height: 42px;
        background: #514DEF;
        border-radius: 4px;
        font-size: 14px;
        font-family: "Source Han Sans SC";
        font-weight: 400;
        color: #FFFFFF;
        border: none;
      }
    }
    .tips{
      margin-top: 16px;
      text-align: center;
      color: #A4A4AD;
      font-size: 14px;
      .el-icon-other-login-chrome{
        background: url('~@/assets/images/icon_login_chrome.png')no-repeat;
        background-position: center center;
        margin: 0 4px;
        display: inline-block;
        width: 14px;
        height: 14px;
      }
    }
  }
  .footer-content{
    height: 68px;
    margin-bottom: 61px;
  }
}

@media only screen and (max-width: 1366px) {
  .other-login-container {
    min-height: 550px;
    padding-top: 20px;
    .other-login-content{
      min-height: calc(100vh - 119px);
      .title-container{
        height: 67px;
      }
      .phone-register {
        height: 482px;
        margin: 40px 0 20px;
        .el-button{
          width: 100%;
          margin-top: 45px;
          height: 36px;
        }
      }
    }
    .footer-content{
      margin-bottom: 30px;
    }
  }
}
</style>
